"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSnakecaseKey = exports.setCamelcaseKey = exports.setValue = exports.isNonArrayObject = exports.isArray = void 0;

var _lodash = _interopRequireDefault(require("lodash.camelcase"));

var _lodash2 = _interopRequireDefault(require("lodash.snakecase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
} // Private functions


var isArray = function isArray(value) {
  return value.constructor === Array;
};

exports.isArray = isArray;

var isNonArrayObject = function isNonArrayObject(value) {
  return _typeof(value) === 'object' && !isArray(value);
}; // Public functions


exports.isNonArrayObject = isNonArrayObject;

var setValue = function setValue(value) {
  return function (key) {
    return _defineProperty({}, key, value);
  };
};

exports.setValue = setValue;

var setCamelcaseKey = function setCamelcaseKey() {
  var transformValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (value) {
    return value;
  };
  return function (key, value) {
    return _defineProperty({}, (0, _lodash.default)(key), transformValue(value));
  };
};

exports.setCamelcaseKey = setCamelcaseKey;

var setSnakecaseKey = function setSnakecaseKey() {
  var transformValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (value) {
    return value;
  };
  return function (key, value) {
    return _defineProperty({}, (0, _lodash2.default)(key), transformValue(value));
  };
};

exports.setSnakecaseKey = setSnakecaseKey;